<template>
    <div>
      <template v-if="node_a in badges">
        {{ node_a }}
        <img :src="badges[node_a]" class="align-middle inline-block" :alt="badges[node_a]['title']"/>
      </template>
      <template v-else>
        {{ node_a }}
      </template>
    </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import useTwitch from '@/Shared/useTwitch'

export default {
  components: {
    Icon,
  },
  props: ['preview_anniversary'],
  data() {
    return { twitchApi: null }
  },
  created() {
    this.twitchApi = useTwitch()
    if (!this.twitchApi.state.badges) this.twitchApi.fetchBadges()
  },
  computed: {
    node_a() {
      try {
          return this.preview_anniversary.match(/\d+/)[0]
        }
      catch (e) {
        return this.preview_anniversary
      }
    },
    badges() {
      return (this.twitchApi && this.twitchApi.state.badges) || {}
    },
  },
}
</script>
